interface SelectionRectProps {
  left: number
  top: number
  width: number
  height: number
}

export function SelectionRect({ left, top, width, height }: SelectionRectProps) {
  return (
    <div
      aria-hidden
      style={{
        position: 'absolute',
        left,
        top,
        width,
        height,
        zIndex: 3,
        pointerEvents: 'none',
        border: '1px solid rgba(99, 102, 241, 0.7)',
        background: 'rgba(99, 102, 241, 0.12)',
        borderRadius: 4,
        boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.08)',
      }}
    />
  )
}
